var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp16G(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help_24",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help_24-g",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_15579",
    "data-name": "Rechteck 15579",
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18717",
    "data-name": "Pfad 18717",
    d: "M8,1a7,7,0,1,0,7,7A7,7,0,0,0,8,1ZM9,13H7V11H9Zm.52783-4.521a2.69113,2.69113,0,0,0-.53418.51172L9,10H7V9A2.61062,2.61062,0,0,1,8.25586,6.93555C8.76172,6.51855,9,6.29053,9,6a.99089.99089,0,0,0-.41064-.80811,1.02337,1.02337,0,0,0-.939-.13574A1.06129,1.06129,0,0,0,7,6.08447H5A3.05826,3.05826,0,0,1,7.0459,3.1499,3.0062,3.0062,0,0,1,11,6,3.2113,3.2113,0,0,1,9.52783,8.479Z",
    fill: "#a3b2bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_15580",
    "data-name": "Rechteck 15580",
    width: 16,
    height: 16,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp16G);
export default __webpack_public_path__ + "static/media/help_16-g.c040a52c68eb72e732f9a64655ecdd87.svg";
export { ForwardRef as ReactComponent };